/* eslint-disable tailwindcss/no-arbitrary-value */
'use client';

import { MaterialIcon } from 'components/modulab/MaterialIcon';
import { AuthorSimple } from '../../components-internal/AuthorSimple';
import {
  ComponentStandoutTextBlock,
  EnumTabTarget,
} from '$/(cms)/_modules/cmsService/types';
import Button from '$/components/Button';

export const LegacyStandoutBody = (props: {
  author?: ComponentStandoutTextBlock['author'];
  buttonClasses: string;
  buttonTarget?: EnumTabTarget;
  buttonText?: string;
  buttonUrl?: string;
  content?: string;
  includeCta?: boolean;
  isPerspective: boolean;
}) => {
  const {
    author,
    buttonClasses,
    buttonTarget,
    buttonText,
    buttonUrl,
    content,
    includeCta,
    isPerspective,
  } = props;

  const showCtaButton = includeCta && buttonText && buttonUrl;
  const shouldRenderAside =
    (isPerspective && Boolean(author?.name)) || Boolean(showCtaButton);

  return (
    <>
      <div className="mhg-alpha-typography-body-2-relaxed whitespace-break-spaces text-text/primary md:flex-1">
        {content}
      </div>
      {shouldRenderAside && (
        <div className="flex w-full flex-col gap-4 md:w-60">
          {isPerspective && author?.name && (
            <div>
              <AuthorSimple author={author} index={0} />
            </div>
          )}

          {showCtaButton && (
            <Button
              as="a"
              variant="outline"
              styleType="primary"
              className={buttonClasses}
              href={buttonUrl}
              endIcon={<MaterialIcon icon="arrow_right_alt" />}
              target={
                buttonTarget === EnumTabTarget.NewTab ? '_blank' : '_self'
              }
              rel={
                buttonTarget === EnumTabTarget.NewTab
                  ? 'noopener noreferrer'
                  : undefined
              }
            >
              {buttonText}
            </Button>
          )}
        </div>
      )}
    </>
  );
};
